/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_GETPROFILEDATA, GETPROFILEDATA_RECEIVED } = constants.GetProfileData;

export default {
  REQUEST_GETPROFILEDATA,
  GETPROFILEDATA_RECEIVED,

  requestGetProfileData: payload => ({
    type: REQUEST_GETPROFILEDATA,
    payload
  }),
  GetProfileDataReceived: () => ({
    type: GETPROFILEDATA_RECEIVED
  })
};
